import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTokenList } from '../../contexts/TokenList'
import EthLogo from '../../assets/eth.png'

const BAD_IMAGES = {}

const Inline = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`

const Image = styled.img`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075);
`

const StyledEthereumLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #b1b4b9;
  border-radius: 50%;
  > img {
    width: ${({ size }) => size};
    height: ${({ size }) => size};
  }
`

const StyledLetterLogo = styled.div`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background-color: #b1b4b9;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`

const tokenLogoPath = (address, tokenList) => {
  if (address && tokenList && tokenList?.length > 0) {
    for (let i = 0; i < tokenList?.length; i++) {
      if (tokenList[i].address.toLowerCase() == address.toLowerCase()) {
        return tokenList[i].logoURI
      }
    }
  }
  return ``
}

const WETH_address = [
  '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  '0xc778417e063141139fce010982780140aa0cd5ab',
  '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
  '0xd0a1e359811322d97991e03f863a0c30c2cf029c'
]

export default function TokenLogo({ address, header = false, size = '24px', ...rest }) {
  const [error, setError] = useState(false)
  const { tokenList } = useTokenList()
  useEffect(() => {
    setError(false)
  }, [address])

  if (error || BAD_IMAGES[tokenLogoPath(address, tokenList)]) {
    return (
      <Inline>
        <StyledLetterLogo {...rest} size={size}>
          {'?'.substring(0, 1).toUpperCase()}
        </StyledLetterLogo>
      </Inline>
    )
  }

  if (WETH_address.includes(address)) {
    return (
      <StyledEthereumLogo size={size} {...rest}>
        <img src={EthLogo} style={{ boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.075)', borderRadius: '24px' }} alt="" />
      </StyledEthereumLogo>
    )
  }
  return (
    <Inline>
      <Image
        {...rest}
        alt={''}
        src={tokenLogoPath(address, tokenList)}
        size={size}
        onError={event => {
          BAD_IMAGES[tokenLogoPath(address, tokenList)] = true
          setError(true)
          event.preventDefault()
        }}
      />
    </Inline>
  )
}
